// Desktop onboarding tour configuration using Intro.js
// Card-based tour for consistent experience across all browsers

export const getIntroSteps = () => {
  return [
    {
      intro: `
        <div style="text-align: center; padding: 20px;">
          <div style="font-size: 48px; margin-bottom: 16px;">🏐</div>
          <h2 style="margin: 0 0 12px 0; color: #2E5AAC;">Welcome to VballStat!</h2>
          <p style="margin: 0 0 16px 0; color: #555; font-size: 14px;">
            Let's take a quick tour to help you get started tracking your volleyball stats.
          </p>
        </div>
      `
    },
    {
      intro: `
        <div style="padding: 20px;">
          <div style="font-size: 40px; margin-bottom: 16px; text-align: center;">👤</div>
          <h3 style="margin: 0 0 8px 0; color: #2E5AAC; text-align: center;">Add Players</h3>
          <p style="margin: 0; color: #555; font-size: 14px; text-align: center;">
            Start by creating player profiles. Track stats for yourself or multiple players on your team.
          </p>
        </div>
      `
    },
    {
      intro: `
        <div style="padding: 20px;">
          <div style="font-size: 40px; margin-bottom: 16px; text-align: center;">📅</div>
          <h3 style="margin: 0 0 8px 0; color: #2E5AAC; text-align: center;">Create Seasons</h3>
          <p style="margin: 0; color: #555; font-size: 14px; text-align: center;">
            Organize your matches by season (e.g., "Spring 2025", "Summer League") to track progress over time.
          </p>
        </div>
      `
    },
    {
      intro: `
        <div style="padding: 20px;">
          <div style="font-size: 40px; margin-bottom: 16px; text-align: center;">📊</div>
          <h3 style="margin: 0 0 8px 0; color: #2E5AAC; text-align: center;">Record Matches</h3>
          <p style="margin: 0; color: #555; font-size: 14px; text-align: center;">
            Log match results and detailed statistics to unlock powerful analytics and insights.
          </p>
        </div>
      `
    },
    {
      intro: `
        <div style="text-align: center; padding: 20px;">
          <div style="font-size: 48px; margin-bottom: 16px;">🎉</div>
          <h2 style="margin: 0 0 12px 0; color: #2E5AAC;">You're All Set!</h2>
          <p style="margin: 0; color: #555; font-size: 14px;">
            Start adding players and recording matches to track your volleyball journey!
          </p>
        </div>
      `
    }
  ];
};

// Intro.js options configuration
export const introOptions = {
  nextLabel: 'Next →',
  prevLabel: '← Back',
  doneLabel: 'Finish',
  skipLabel: '× Skip Tour',
  showProgress: true,
  showBullets: false,
  exitOnOverlayClick: false,
  exitOnEsc: true,
  overlayOpacity: 0.7,
  tooltipClass: 'vballstat-intro-tooltip',
  showStepNumbers: false
};
